import { useLocation } from 'react-router-dom';

const INTENDED_URL_LS_KEY = 'transport.intended_url';

export function useIntendedUrl() {
  const { pathname, search } = useLocation();

  function clear() {
    window.localStorage.removeItem(INTENDED_URL_LS_KEY);
  }

  function set() {
    window.localStorage.setItem(INTENDED_URL_LS_KEY, `${pathname}${search}`);
  }

  function get() {
    return window.localStorage.getItem(INTENDED_URL_LS_KEY);
  }

  return {
    clear,
    get,
    set,
  };
}
